// extracted by mini-css-extract-plugin
export const logo = "tobogganlogo-module--logo--20_Q1";
export const rotation = "tobogganlogo-module--rotation--2ReTP";
export const inverted = "tobogganlogo-module--inverted--353WB";